import React from 'react'

const SvgBellOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M18 16h1c.667 0 1 .333 1 1s-.333 1-1 1H5c-.667 0-1-.333-1-1s.333-1 1-1h1v-5.961a6.032 6.032 0 014-5.677V4a2 2 0 114 0v.34c2.328.81 4 3.016 4 5.621V16zm-2 0v-6a4 4 0 10-8 0v6h8zm-6 4a2 2 0 004 0h-4z' />
  </svg>
)

export default SvgBellOutline
